import React from 'react';

import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';

import { RewardsBase } from './components/rewards-base';

export const RewardsPage = React.memo(() => {
  return (
    <>
      <LoyaltyRewardsTabs />
      <RewardsBase />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.REWARD} />
    </>
  );
});
